import PropTypes from 'prop-types';
import { withStyles, Tooltip } from '@material-ui/core';
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons';

import { SwitchControl } from '~/components';

const muiStyles = theme => ({
  formControl: {
    display: 'flex',
    alignItems: 'flex-end',
    height: '100%',
  },
  nonEngineeredWrapper: {
    display: 'flex',
    height: '56px',
    alignItems: 'flex-end',
    marginLeft: '8px',
  },
  infoIcon: {
    marginLeft: '8px',
    marginBottom: '12px',
    fontSize: '13px',
    color: theme.palette.primary.text6,
    '&:hover': {
      color: theme.palette.primary.text1,
    },
  },
  infoTooltip: {
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: theme.palette.primary.text1,
    minWidth: '314px',
  },
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
  },
});

function NonEngineeredWellsSwitch({ value, onChange, classes, 'data-testid': dataTestId }) {
  const handleChangeValue = e => {
    onChange(e.target.checked);
  };

  return (
    <div className={classes.nonEngineeredWrapper}>
      <SwitchControl
        data-testid={dataTestId}
        rightLabel="Include Non-Verified Reference Wells"
        color="primary"
        checked={value}
        onChange={handleChangeValue}
        size="small"
        className={classes.formControl}
      />
      <Tooltip
        title={
          <div className={classes.tooltipContent}>
            <span>
              Non-Verified Reference Wells have minimal data and are used for displaying drilling
              parameters only.
            </span>
            <span>Metrics & models from these wells can be inaccurate.</span>
          </div>
        }
        placement="bottom-start"
        classes={{
          tooltip: classes.infoTooltip,
        }}
      >
        <InfoOutlinedIcon fontSize="small" className={classes.infoIcon} />
      </Tooltip>
    </div>
  );
}

NonEngineeredWellsSwitch.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.shape({}).isRequired,
  'data-testid': PropTypes.string,
};

NonEngineeredWellsSwitch.defaultProps = {
  'data-testid': 'NonEngineeredWellsSwitch',
};

export default withStyles(muiStyles)(NonEngineeredWellsSwitch);
